import React from 'react';

import SelectReason from '@components/block-reorder/select-reason/SelectReason';

const SelectReasonPage = () => (
    <div className="sgw-layout medium-centered-container">
        <div className="sgw-layout-item">
            <SelectReason />
        </div>
    </div>
);

export default SelectReasonPage;
